import { render, staticRenderFns } from "./tCreditNoteNew.vue?vue&type=template&id=13e4e26c"
import script from "./tCreditNoteNew.vue?vue&type=script&lang=js"
export * from "./tCreditNoteNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports